import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "status-container"
}
const _hoisted_3 = { class: "status-label" }
const _hoisted_4 = { class: "status-value" }

import { ref, watch } from 'vue';
import i18n from '@/lang/i18n';
import Api from "@/services/api/ApiServiceFabrick";
import type getMonthlyReportPreCreateStatusResponse from "@/types/responses/getMonthlyReportPreCreateStatus";
import { MONTHLY_REPORT_STATUS_ITEMS } from "@/services/consts";
import { isLaravelValidationError } from '@/types/LaravelValidationError';


export default /*@__PURE__*/_defineComponent({
  __name: 'MonthlyReportPreCreateStatus',
  props: {
    operationOfficeId: {},
    yearMonth: {}
  },
  setup(__props: any) {

const props = __props;

const status = ref<getMonthlyReportPreCreateStatusResponse | null>(null);
const loading = ref(false);

async function fetchStatus() {
  if (!props.operationOfficeId || !props.yearMonth) {
    return;
  }

  loading.value = true;
  try {
    const response = await Api().getMonthlyReportPreCreateStatus({
      operation_office_id: props.operationOfficeId,
      year_month: props.yearMonth
    });
    status.value = response;
  } catch (error: unknown) {
    status.value = null;
    if (isLaravelValidationError(error)) {
      console.error(error.response);
    } else {
      console.error(error);
    }
  } finally {
    loading.value = false;
  }
}

// operationOfficeIdまたはyearMonthが変更されたとき、および初回マウント時にAPIを実行
watch([() => props.operationOfficeId, () => props.yearMonth], () => {
  fetchStatus();
}, { immediate: true });


return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createBlock(_component_v_col, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(i18n).global.t('pages.monthlyReport.preCreateStatus.loading')), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MONTHLY_REPORT_STATUS_ITEMS), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.key,
                class: "status-item"
              }, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(i18n).global.t(`pages.monthlyReport.preCreateStatus.${item.key}`)), 1),
                _createElementVNode("span", _hoisted_4, _toDisplayString(status.value ? status.value[item.field as keyof typeof status] : '-'), 1)
              ]))
            }), 128))
          ]))
    ]),
    _: 1
  }))
}
}

})